import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const styles = theme => ({
    root: {
        display: "flex"
    },
    formControl: {
        // margin: theme.spacing.unit * 3
    },
    group: {
        // margin: `${theme.spacing.unit}px 0`,
        flexDirection: "row"
    },
    isChecked: {
        color: '#005458 !important'
    }
});

class RadioElement extends React.Component {
    state = {
        value: '2',
    };

    handleChange = event => {
        this.setState({ value: event.target.value });
    };

    render() {
        const { classes } = this.props;
        const { label, name, handleChange, value, options } = this.props

        return (
            <div className={classes.root}>
                <FormControl component="fieldset" className={classes.formControl}>
                <label
                htmlFor={this.id}
            >Destination Type
            </label>
                    <RadioGroup
                        aria-label={label}
                        name={name}
                        className={classes.group}
                        value={value ? value : this.state.value}
                        onChange={handleChange}
                    >
                    {options && Object.keys(options).map((option, index) => (
                        <FormControlLabel key={index} value={options[option].id} control={<Radio classes={{
                            checked: classNames(classes.isChecked)
                        }} />} label={options[option].name} />
                    ))}
                    </RadioGroup>
                </FormControl>

            </div>
        );
    }
}

RadioElement.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RadioElement);



// WEBPACK FOOTER //
// ./src/components/FormElement/RadioElement.js